import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { useSentryBreadcrumbs } from '../../hooks/use-sentry-user'

interface SentryRouterIntegrationProps {
  children: React.ReactNode
}

export function SentryRouterIntegration({ children }: SentryRouterIntegrationProps) {
  const location = useLocation()
  const { addNavigation } = useSentryBreadcrumbs()

  useEffect(() => {
    addNavigation(location.pathname + location.search)

    Sentry.setContext('route', {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      key: location.key
    })

    Sentry.setTag('route.pathname', location.pathname)
  }, [location, addNavigation])

  return <>{children}</>
}
